module.exports = __webpack_public_path__ + "static/img/IMG_20160821_144553.c244d603.jpg";